// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__3oJZp","large":"button_large__2E5MM"};